import { render, staticRenderFns } from "./licaidel.vue?vue&type=template&id=ecfb60a4&scoped=true"
import script from "./licaidel.vue?vue&type=script&lang=js"
export * from "./licaidel.vue?vue&type=script&lang=js"
import style0 from "./licaidel.vue?vue&type=style&index=0&id=ecfb60a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfb60a4",
  null
  
)

export default component.exports